import { styled } from '@mui/material/styles';

import AtomGrid from '../../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../../components/resources/styleConfigs';
import palette from '../../../../theme/learnerPalette';

export const GridNotification = styled(AtomGrid)(({ backgroundcolor }: { backgroundcolor?: string }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  backgroundcolor,
  paddingRight: styleConfigs.marginPadding.custom3,
  borderBottom: `${styleConfigs.borders.borderLine} ${palette.light.borders.white}`,
}));

export const IconBackground = styled('div')(() => ({
  width: styleConfigs.dimensions.width40,
  height: styleConfigs.dimensions.height40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: palette.light.background.springWood,
  borderRadius: styleConfigs.borders.borderRound,
}));
